import { injectIntl } from "react-intl";
import { useEffect, useState } from "react";

const TableHeader = (props) => {
  const [sort, setSort] = useState();

  useEffect(() => {
    setSort(props.sort);
  }, [props.sort]);

  const handleSort = (activeIndex) => {
    const key = props.sortType?.[activeIndex];
    const isAscending = !sort[activeIndex]?.active;

    // If onSortChange callback is provided, use it for API sorting
    if (props.onSortChange) {
      props.onSortChange(key, isAscending);
    } else if (props.sortList) {
      props.sortList(activeIndex);
    } else if (props.setList) {
      const list = Array.isArray(props.list) ? props.list : [];
      const compare = (a, b) => {
        if (typeof a[key] === "string") {
          return a[key].localeCompare(b[key]);
        }
        return a[key] - b[key];
      };
      const sorted = [...list].sort((a, b) =>
        sort[activeIndex]?.active ? compare(b, a) : compare(a, b)
      );
      props.setList(sorted);
    }

    setSort((prevSort) =>
      prevSort.map((item, i) =>
        i === activeIndex
          ? { ...item, active: !item.active }
          : { ...item, active: false }
      )
    );
  };

  return (
    <div className={"TableHeader"}>
      {props.titles?.map((header, index) => {
        const textAlign =
          props.textAlignments && props.textAlignments[index] === "right"
            ? "text-end"
            : "";
        const flexJustify =
          props.textAlignments && props.textAlignments[index] === "right"
            ? "justify-end"
            : "";
        const showIcon =
          props.showIconForColumns && props.showIconForColumns[index] === true;
        return (
          <div
            className={`flex items-center h-full py-2 px-[10px] gap-1 ${flexJustify}`}
            style={{ width: props.widths[index] }}
          >
            {showIcon && (
              <img
                alt={"Logo"}
                src={"/media/icons/currency-dollar-circle.svg"}
                className={"w-3 h-3"}
              />
            )}
            <div className={`HeaderNameSection ${textAlign}`}>{header}</div>
            {sort && sort[index]?.sorting && (
              <button onClick={() => handleSort(index)}>
                <img
                  alt={"Logo"}
                  src={
                    sort[index].active
                      ? "/media/icons/chevronUp.svg"
                      : "/media/icons/chevronDown.svg"
                  }
                  className={"w-3 h-3"}
                />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default injectIntl(TableHeader);
